/**
 * Vendor Attribution Saga
 */
import { all, call, put, takeLatest } from 'redux-saga/effects';
import Actions from './actions';
import Constants from '../../constants';
import UserAPI from '../../Lib/Api/user';
import { handleError } from '../../Lib/Utils/saga-utils';

const { VendorAttribution } = Constants;

/**
 * Creates vendor attributes
 *
 * @param {object} action action object containing type and payload properties
 */
export function* createVendorAttributes({ vendorAttributes }) {
  try {
    const response = yield call(
      UserAPI.createVendorAttributes,
      vendorAttributes,
    );
    yield put(Actions.createVendorAttributesSuccess(response));
  } catch (err) {
    yield handleError(Actions.createVendorAttributesError, err);
  }
}

/**
 * updates vendor attributes
 *
 * @param {object} action action object containing type and payload properties
 */
export function* updateVendorAttributes({ userId, update }) {
  try {
    const response = yield call(UserAPI.updateVendorAttributes, userId, update);
    yield put(Actions.updateVendorAttributesSuccess(response));
  } catch (err) {
    yield handleError(Actions.updateVendorAttributesError, err);
  }
}

function* vendorAttributionSaga() {
  yield all([
    yield takeLatest(
      VendorAttribution.CREATE_VENDOR_ATTRIBUTES,
      createVendorAttributes,
    ),
    yield takeLatest(
      VendorAttribution.UPDATE_VENDOR_ATTRIBUTES,
      updateVendorAttributes,
    ),
  ]);
}

export default vendorAttributionSaga;
